import { Link } from 'react-router-dom';

// third-party
import { FormattedMessage } from 'react-intl';

// project import
import { buttonStyle } from 'components/buttons/buttonStyle';
import { Button } from 'components/ui/button';
import AuthWrapper from 'sections/auth/AuthWrapper';

// ================================|| CHECK MAIL ||================================ //

type Props = Record<string, unknown>;

const CheckMail: React.FC<Props> = ({ email }) => {
    return (
        <AuthWrapper>
            <div className="flex flex-col gap-6">
                <div className="sm:mb-1">
                    <h3 className="text-h3 text-balance">
                        <FormattedMessage id="auth.hi-check-email" />
                    </h3>
                    <p className="text-body1 text-secondary mt-2.5">
                        <FormattedMessage id="auth.password-recovery-instructions-sent-to-email" />
                    </p>
                </div>
                <Button
                    {...buttonStyle({ variant: 'contained' }, 'flex w-full')}
                    nativeButton={false}
                    role="link"
                    render={<Link to={email ? `/code-verification?to=${email}` : '/code-verification'} />}
                >
                    <FormattedMessage id="auth.verify-code" />
                </Button>
            </div>
        </AuthWrapper>
    );
};

export default CheckMail;
